import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    SidebarMenuButton,
} from '@/shared/components/ui/sidebar'
import React from 'react'
import { CircularDurationDisplay } from './DurationDisplay'
import { useV2SContext } from './V2SProvider'
import { Upload } from 'lucide-react'
import { SelectLanguage } from './SelectLanguage'

const V2SOptionbar = ({ ...props }: React.ComponentProps<typeof Sidebar>) => {
    const { totalDuration } = useV2SContext()
    return (
        <Sidebar
            collapsible="none"
            className="sticky top-0 hidden h-svh border-l lg:flex"
            {...props}
        >
            {' '}
            <SidebarHeader></SidebarHeader>
            <SidebarContent>
                <CircularDurationDisplay duration={totalDuration} heading="Narration Recorded" />
                <SelectLanguage />
            </SidebarContent>
            <SidebarFooter>
                <SidebarMenuButton>
                    <Upload />
                    <span>Upload</span>
                </SidebarMenuButton>
            </SidebarFooter>
        </Sidebar>
    )
}
export default V2SOptionbar
